import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

class MaxRuntimeValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;

    constructor() {}

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpMaxRuntime'] = (
            modelValue: DateInterval
        ): boolean => {
            const maxRuntime: moment.Moment = moment(
                scope.$eval(attrs.pkpMaxRuntime)
            );
            if (
                maxRuntime == null ||
                modelValue == null ||
                modelValue.end == null
            )
                return true;
            return (moment(modelValue.end) as moment.Moment).isSameOrBefore(
                maxRuntime
            );
        };

        attrs.$observe('pkpMaxRuntime', () => ngModelCtrl.$validate());
    };
}

angular
    .module('app')
    .directive('pkpMaxRuntime', () => new MaxRuntimeValidator());
